import React from "react";
import ServiceBody from "../MainServicePage/ServiceBody";
import { android_data } from "../ServicesDisplayPage/servicesData";

const Check_appdev = () => {
  // Pick the correct service from servicesData.js
  const service_steps = {
    data: android_data,
    title: "App Development",
    description: "Learn Mobile App Development with React Native & Expo",
    registerPath: "/Register_android",
  };

  return (
    <>
      <ServiceBody service_steps={service_steps} />
    </>
  );
};

export default Check_appdev;
